var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUndo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.193,
    height: 24.335,
    viewBox: "0 0 27.193 24.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_265",
    "data-name": "Rectangle 265",
    width: 27.193,
    height: 24.335,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M4.871,9.464a.637.637,0,0,0,.232.3q2.013,1.992,4.028,3.981A1.391,1.391,0,0,1,9.2,15.8a1.368,1.368,0,0,1-1.913.04c-.2-.182-.392-.383-.587-.576Q3.632,12.231.561,9.194a1.42,1.42,0,0,1,0-2.26Q3.849,3.69,7.142.452A1.371,1.371,0,0,1,9.147.42,1.373,1.373,0,0,1,9.08,2.426Q7.069,4.419,5.051,6.405c-.079.079-.184.139-.224.263A.745.745,0,0,0,5.2,6.7c4.4,0,8.8.03,13.194-.007A8.813,8.813,0,0,1,19.8,24.2a20.213,20.213,0,0,1-3.155.128c-.517,0-1.034.007-1.55,0a1.406,1.406,0,1,1-.007-2.8c1.128-.011,2.257,0,3.385-.006a6.029,6.029,0,0,0,.881-11.977,5.076,5.076,0,0,0-.817-.074q-6.708-.007-13.416,0H4.871",
    transform: "translate(0 0.001)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUndo);
export default __webpack_public_path__ + "static/media/icon_undo.1553f0ee41f42b1149c4df7a55e447b5.svg";
export { ForwardRef as ReactComponent };